import React, { Component } from "react"

export default class LuckyStars extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Lucky Stars</p>
            <p className="portdesctext">Submission for <a href = "https://hochkantfilmfest.de/en/intro-en-2/" target="_blank" rel="noopener noreferrer">Hochkantfilmfest 15</a> which was selected as 1 of 17 from over 100 submissions to be displayed in the city center of Bremen, Germany. 10 second animation made in photoshop hand drawn frame by frame. Abstract <a href = "https://www.dropbox.com/s/l9psaiojcqoskfw/Lucky%20Stars%20%28publish%29.pdf?dl=0" target="_blank" rel="noopener noreferrer">here</a> and animation "Lucky Stars" is in link below.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://www.dropbox.com/s/yeq624guj81t0vy/15_HKFF_Digitaldeluxenet_Bremen_AliRazzakandLuckyStars.mp4?dl=0" target="_blank" rel="noopener noreferrer"><p className="linktext">Video</p></a>
        </div>
      </div>
  )
}
}

